export default class Option {
    constructor(
        public value: string | number,
        public text: string,
        public selected: boolean
    ) {
    }
}
